
import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Paper } from '@mui/material';
import { useStateIfMounted } from 'use-state-if-mounted'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'
import { obtenerFC_05Detalle } from '../../redux/FC_05Ducks';
import { AcualizarFormatoAccion } from '../../redux/AtencionAClienteDucks'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function RevicionAtencionAClientesComponent(props) {

    const dispatch = useDispatch()
    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const boton = async () => {
        handleOpenModal()
    }
    const solicitudes = useSelector(store => store.AtencionSolicitud.detalle)
    const val = Number(solicitudes.detalle.data.idSolicitud)
    React.useEffect(() => {
        if (solicitudes.detalle.data.tabla == 1) {
            
        }
        if (solicitudes.detalle.data.tabla == 2) {
            const resultado =  dispatch(obtenerFC_05Detalle(val))
            
        }
        if (solicitudes.detalle.data.tabla == 3) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 4) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 5) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 6) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 7) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 8) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 9) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 10) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 11) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 12) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }
        if (solicitudes.detalle.data.tabla == 13) {
            //React.useEffect(() => {
            //const resultado =  dispatch(obtenerFC_05Detalle({ val }))
            //}
        }        
    }, [])
    
    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="red" align='center'>
                            ¡Advertencia!
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                            y los datos se tomarán como válidos.<br /> <strong>¿Desea continuar?</strong>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={botonAceptarSolicitud}>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = () => setOpenModalDevolver(true);
    const handleCloseModalDevolver = () => setOpenModalDevolver(false);

    const botonDevolver = async () => {
        let bandera = false
        const estatus = 5
        const tabla = solicitudes.detalle.data.tabla
        const idSolicitud = solicitudes.detalle.data.idSolicitud
        const idlogin = solicitudes.detalle.data.idlogin
        const resultado = await dispatch(AcualizarFormatoAccion({tabla,idSolicitud,estatus,idlogin}))
        if (tabla == 1) {
            bandera = true
            
        }else{
            bandera = true
        }
        
        if (bandera) {
            props.history.push('/AtencionAClientesComponent')
        } else {
            // console.log("error")
        }
    }

    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="red" align='center'>
                            ¡Advertencia!
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Está a punto de devolver la solicitud, ya no podrá seguir revisándola
                            y la solicitud regresará al cliente.<br /> <strong>¿Desea continuar?</strong>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' >CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>

        )
    }

    const botonAceptarSolicitud = async () => {
        let bandera = false
        const estatus = 4
        const tabla = solicitudes.detalle.data.tabla
        const idSolicitud = solicitudes.detalle.data.idSolicitud
        const idlogin = solicitudes.detalle.data.idlogin
        const resultado = await dispatch(AcualizarFormatoAccion({tabla,idSolicitud,estatus,idlogin}))
        if (tabla == 1) {
            bandera = true
            
        }else{
            bandera = true
        }
        
        if (bandera) {
            props.history.push('/AtencionAClientesComponent')
        } else {
            // console.log("error")
        }
    }

    return (

        <div className='row align-items-center'>
            <div className="input-group flex-nowrap">
                <br />
                <br />
                <br />
                <br />
                hola
                <br />
                <br />
                <br />
            </div>
            <div className="input-group flex-nowrap">
                <div className='col-md-8'>
                    <textarea type="textarea" rows="5" className="form-control" id="" placeholder='Detalle del servicio.' />
                </div>
                <div className="btn-group" role="group" aling="center" >
                    <div className='col-md-12'>
                        <button type="button" className="btn btn-outline-primary" onClick={boton}>Aceptar Solicitud</button>
                    </div>
                    <br />
                    <div className='col-md-12'>
                        <button type="button" className="btn btn-outline-primary" onClick={botonDevolver}>Devolver solicitud a beneficiario</button>
                    </div>

                </div>
            </div>
            {modalComponent()}
            {modalComponentDevolver()}
        </div>

    )
    /*<button type="button" className="btn btn-outline-primary">Editar cambios</button>
      <button type="button" className="btn btn-outline-primary">Guardar Cambios</button> */
}
export default withRouter(RevicionAtencionAClientesComponent)
